import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'
import { UiPillType } from '@src/types'
import { Pill, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { InsurancePoliciesQuery } from '../graphql/fetchInsurancePolicies.generated'
import { InsurancePolicyState } from './InsurancePolicyState'

interface InsurancePolicyProps {
  insurancePolicy: InsurancePoliciesQuery['insurancePolicies']['insurancePolicies'][0]
  style?: StyleProp<ViewStyle>
}

export const InsurancePolicyComponent = (props: InsurancePolicyProps) => {
  const styles = useStyleSheet(themedStyles)
  const { style, insurancePolicy } = props

  return (
    <View style={[styles.container, style]}>
      <View style={styles.column}>
        <View style={styles.row}>
          {insurancePolicy.last && (
            <Pill style={styles.pill} text="Active" status={UiPillType.Success} />
          )}
          <Text type="small" style={styles.benefitsCheckText}>
            Benefits Check Status
          </Text>
        </View>
        <View style={styles.row}>
          <InsurancePolicyState insurancePolicy={insurancePolicy} />
        </View>
      </View>
    </View>
  )
}

const themedStyles = StyleService.create({
  container: {
    borderWidth: 2,
    borderRadius: 16,
    padding: 12,
    borderColor: 'theme.surface.base1',
    flexDirection: 'row',
    justifyContent: 'space-between',
    minHeight: 74,
  },
  benefitsCheckText: {
    color: 'theme.text.secondary',
    textAlign: 'right',
    flex: 1,
  },
  column: {
    flex: 1,
    justifyContent: 'space-between',
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
  },
  pill: {
    marginRight: 16,
    height: 28,
  },
})
